var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { distinct, map, tap } from 'rxjs/operators';
import { date } from './date.service';
import { MatDialog } from '@angular/material';
import { CommunicationPopupComponent } from '@components/communication-popup/communication-popup.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/material/dialog";
var CommunicationService = /** @class */ (function () {
    function CommunicationService(http, dialog, baseUrl) {
        this.http = http;
        this.dialog = dialog;
        this.baseUrl = baseUrl;
        this.apiUrl = this.baseUrl + "api/communications";
    }
    CommunicationService.prototype.getCommunication = function (id) {
        if (id === 'new') {
            return of({});
        }
        return this.http.get(this.apiUrl + "/" + id);
    };
    /**
     * Get the currently un-read communications for a user.
     */
    CommunicationService.prototype.getUnreadCommunications = function () {
        var _this = this;
        return this.http.get(this.apiUrl + "/unread").pipe(tap(function (comms) { return date(comms, 'publishDate', 'expiryDate'); }), tap(function (comms) { return comms.sort(_this.sortCommunicationsDescending); }));
    };
    CommunicationService.prototype.sortCommunicationsDescending = function (a, b) {
        return a.publishDate.getTime() > b.publishDate.getTime() ? -1 : 1;
    };
    /**
     * Looks up the unread communications/announcements for the logged in user and
     * displays them in popup dialogs.
     */
    CommunicationService.prototype.showUnreadCommunications = function () {
        var _this = this;
        this.getUnreadCommunications()
            .pipe(distinct())
            .subscribe(function (communications) {
            communications.forEach(function (comm) {
                _this.showCommunications(comm);
            });
        });
    };
    CommunicationService.prototype.showCommunications = function (communication) {
        var _this = this;
        var ref = this.dialog.open(CommunicationPopupComponent, {
            minWidth: '500px',
            minHeight: '400px',
            maxWidth: '80vw',
            maxHeight: '80vw',
            width: '',
            data: {
                communication: communication
            }
        });
        ref.afterClosed().subscribe(function (data) {
            _this.markCommunicationRead(communication).subscribe();
        });
    };
    /**
     * Get all the communications available, sorted by the publish date in descending order.
     */
    CommunicationService.prototype.getCommunications = function () {
        var _this = this;
        return this.http.get("" + this.apiUrl).pipe(tap(function (comms) { return date(comms, 'publishDate', 'expiryDate'); }), tap(function (comms) { return comms.sort(_this.sortCommunicationsDescending); }));
    };
    CommunicationService.prototype.putCommunication = function (id, communicationModel) {
        return this.http.put(this.apiUrl + "/" + id, communicationModel);
    };
    CommunicationService.prototype.markCommunicationRead = function (comm) {
        return this.http.put(this.apiUrl + "/markRead", comm);
    };
    CommunicationService.prototype.searchCommunications = function (options) {
        var params = {};
        Object.keys(options)
            .filter(function (x) { return options[x] !== null; })
            .forEach(function (x) {
            params[x] = options[x].toString();
        });
        return this.http.get(this.apiUrl + "/search", { params: params });
    };
    CommunicationService.prototype.deleteCommunication = function (communicationID) {
        return this.http.delete(this.apiUrl + "/" + communicationID);
    };
    CommunicationService.prototype.copyCommunication = function (communicationID) {
        return this.http.get(this.apiUrl + "/copy/" + communicationID);
    };
    CommunicationService.prototype.setCommunication = function (communicationModel) {
        if (communicationModel.id) {
            // Update existing
            return this.http
                .put(this.apiUrl + "/" + communicationModel.id, communicationModel)
                .pipe(map(function (_) {
                return __assign({}, communicationModel);
            }));
        }
        else {
            // Create new
            return this.http
                .post("" + this.apiUrl, communicationModel)
                .pipe(tap(function (communication) { return date(communication, 'publishDate', 'expiryDate'); }));
        }
    };
    CommunicationService.ngInjectableDef = i0.defineInjectable({ factory: function CommunicationService_Factory() { return new CommunicationService(i0.inject(i1.HttpClient), i0.inject(i2.MatDialog), i0.inject("BASE_URL")); }, token: CommunicationService, providedIn: "root" });
    return CommunicationService;
}());
export { CommunicationService };
